import React from "react";
import HeroSection from "../components/HeroSection";
import HomeAbout from "../components/HomeAbout";
import ProductGrid from "../components/ProductGrid";
import WhyChooseUs from "../components/WhyChooseUs";
import RecentImgeSlider from "../components/RecentImgeSlider";
import StatsSection from "../components/StatSection";
import FaqBrandSection from "../components/FaqBrandSection";

const Home = () => {
  return (
    <>
      <HeroSection />
      <HomeAbout />
      <ProductGrid />
      <WhyChooseUs/>
      <RecentImgeSlider/>
      <StatsSection/>
      <FaqBrandSection/>
    </>
  );
};

export default Home;
